import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

const propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  format: PropTypes.func
};

const PlainTextFieldValidate = ({
  name,
  label,
  value,
  className,
  format,
  validate,
}) => {
  //const error = validate ? validate(value) : undefined;
  console.log('vald',validate)
 const error = validate ?validate:undefined;// validate(value) : undefined;
  return (
    <div className="media">
      <label htmlFor={name} className="col-form-label">
        {label}
      </label>
      <div className="media-body">
        <Input id={name} plaintext>
          {value ? (format ? format(value) : value) : ' - '}
        </Input>

        {error && (
          <div className="text-danger">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

PlainTextFieldValidate.propTypes = propTypes;

export default PlainTextFieldValidate;
